import _ from 'lodash';

const isTemplateValue = val => _.isString(val) && val.includes('{{');

export const getReapiKey = () => {
  const windowKey = window.reapiApiKey;

  if (windowKey && !isTemplateValue(windowKey)) {
    return windowKey;
  }

  return process.env.RE_AUTOCOMPLETE_API_KEY;
};

export const getGoogleKey = () => {
  const windowKey = window.googlePlacesApiKeyNew;

  if (windowKey && !isTemplateValue(windowKey)) {
    return windowKey;
  }

  return process.env.GOOGLE_PLACES_API_KEY_NEW;
};
